import { instance, errorService } from '@/services/api'
import { masterAPIs, settingAPIs, screenType } from '@/services/authConstantsV1'
import { calculateGridHeight, showNotification, customComparator } from '@/services/calculate'
import { gridProperties } from '@/services/column.config'
import _ from 'lodash'
import { AgGridVue } from 'ag-grid-vue'
import Pagination from '@/components/DynamicComponents/Pagination'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import moment from 'moment-timezone'
import exportTemplates from '@/components/DynamicComponents/exportTemplates'
import importTemplates from '@/components/DynamicComponents/importTemplates'

export default {
  components: {
    'ag-grid-vue': AgGridVue,
    Pagination,
    DatePicker,
    exportTemplates,
    importTemplates,
  },
  props: {
    tabKey: String,
    role: String,
  },
  data: function () {
    const checkLength = (rule, value, callback) => {
      let reg = /^(?!$)\d{0,16}(?:\.\d{1,4})?$/
      if (rule.field === 'year') {
        reg = /^\d*(d+)?$/
        if (!reg.test(value)) {
          callback(new Error('Please enter valid value'))
        } else if (String(value).length !== 4) {
          callback(new Error('Year must be consist of 4 digits only'))
        } else {
          callback()
        }
      } else {
        if (!reg.test(value)) {
          callback(
            new Error(
              'Please enter valid historical cost index (e.g.: 1234567890123456.1234)',
            ),
          )
        } else if (value > 9999999999999999.9999) {
          callback(
            new Error(
              'Historical cost index should less than or equals to 9999999999999999.9999!',
            ),
          )
        } else {
          callback()
        }
      }
    }
    return {
      headStyle: {
        'font-weight': 'bold',
        background: 'transparent !important',
        color: '#000000d9 !important',
        padding: '0 10px',
      },
      count: 0,
      loading: false,
      spinner: false,
      defaultSortedBy: 'year',
      defaultSortOrder: false,
      page: 0,
      pageSize: 0,
      costList: [],
      visible: false,
      modalTitle: '',
      form: {
        id: undefined,
        year: undefined,
        costIndex: undefined,
        isActive: 1,
      },
      rules: {
        year: [
          { required: true, message: 'Please enter year', trigger: 'blur' },
          { validator: checkLength, trigger: 'blur' },
        ],
        costIndex: [
          {
            required: true,
            message:
              'Please enter valid historical cost index (e.g.: 1234567890123456.1234)',
            trigger: 'blur',
          },
          { validator: checkLength, trigger: 'blur' },
        ],
      },
      selectedRowKeys: [],
      loadRefresh: false,
      gridOptions: null,
      columnDefs: [],
      frameworkComponents: null,
      tableParams: null,
      width: '100%',
      height: '400px',
      filters: {},
      takeoffYear: null,
      settingId: null,
      exportClicked: false,
      uploadedFile: null,
      importClicked: false,
      importColDef: gridProperties.import.columns.historicalCostIndex,
      loadImport: false,
      tableState: null,
    }
  },
  beforeMount() {
    const settings = JSON.parse(localStorage.getItem('userSettings'))
    this.pageSize = settings.application.defaultRecord
    this.takeoffYear = settings.application.takeoffYear
    this.settingId = settings.id
    this.loadConfig()
  },
  mounted() {
    this.$root.$on('deleteCostIndex', this.deleteCostIndex)
    this.$root.$on('editCostIndex', this.getCostIndexById)
    window.addEventListener('resize', this.getWindowSize)
  },
  watch: {
    tabKey() {
      if (this.tabKey === '13') {
        this.filters = {}
        const data = this.gridOptions.api.getFilterModel()
        Object.keys(data).forEach(element => {
          const filterComponent = this.gridOptions.api.getFilterInstance(
            element,
          )
          filterComponent.setModel(null)
        })
        this.costList = []
        this.loading = true
        this.getColumnSettings(this.gridOptions)
      }
    },
  },
  beforeDestroy() {
    this.$root.$off('editCostIndex')
    this.$root.$off('deleteCostIndex')
    window.removeEventListener('resize', this.getWindowSize)
  },
  methods: {
    loadConfig() {
      this.gridOptions = {
        alwaysShowVerticalScroll: true,
        debounceVerticalScrollbar: true,
        alwaysShowHorizontalScroll: true,
        headerHeight: 30,
        rowHeight: 28,
        suppressRowClickSelection: true,
        singleClickEdit: true,
        stopEditingWhenGridLosesFocus: true,
        tooltipShowDelay: 0,
        rowSelection: 'multiple',
        defaultColDef: {
          sortable: true,
          suppressMovable: true,
          comparator: customComparator,
          resizable: true,
          menuTabs: ['filterMenuTab'],
          filterParams: {
            buttons: ['apply'],
            newRowsAction: 'keep',
          },
        },
      }
      this.frameworkComponents = gridProperties.master.frameworks
      this.columnDefs = gridProperties.master.columns.historicalCostIndex
    },

    // Refresh HCI
    refreshCostIndex() {
      const data = this.gridOptions.api.getFilterModel()
      Object.keys(data).forEach(element => {
        const filterComponent = this.gridOptions.api.getFilterInstance(element)
        filterComponent.setModel(null)
      })
      this.loading = true
      this.loadRefresh = true
      this.costList = []
      this.page = 0
      this.defaultSortedBy = 'year'
      this.defaultSortOrder = false
      this.gridOptions.columnApi.applyColumnState({
        state: [
          {
            colId: 'year',
            sort: 'desc',
          },
        ],
        defaultState: { sort: null },
      })
      this.selectedRowKeys = []
      this.gridOptions.api.destroyFilter()
      this.filters = {}
      this.getCost(this.gridOptions)
    },

    // Close the dialog
    handleCancel() {
      this.visible = false
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.resetFields()
      }
    },

    // Add New HCI
    addNew() {
      this.visible = true
      this.modalTitle = 'Add New Historical Cost Index'
      this.form.id = null
      this.form.year = undefined
      this.form.costIndex = undefined
      this.form.isActive = 1
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.resetFields()
      }
    },

    // Save HCI
    save() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.spinner = true
          let url = masterAPIs.costIndex.add
          let method = 'post'
          const req = {
            year: this.form.year,
            costIndex: this.form.costIndex,
          }
          if (this.form.id) {
            url = masterAPIs.costIndex.details(this.form.id)
            method = 'patch'
          }
          instance[method](url, req)
            .then(response => {
              this.spinner = false
              this.visible = false
              showNotification(
                'success',
                this.form.id
                  ? 'Update Historical Cost Index'
                  : 'Create Historical Cost Index',
                this.form.id
                  ? 'Historical Cost Index updated successfully!'
                  : 'Historical Cost Index created successfully!',
              )
              if (this.form.id) {
                const newData = [...this.costList]
                const index = newData.findIndex(i => i.id === this.form.id)
                newData[index] = _.get(response.data, 'result', null)
                this.costList = newData
              } else {
                this.getCost(this.tableParams)
              }
              this.$refs.ruleForm.resetFields()
            })
            .catch(error => {
              this.spinner = false
              errorService(error)
            })
        }
      })
    },

    // Load HCI
    getCost(params, type) {
      this.loadRefresh = true
      this.loading = true
      instance
        .post(masterAPIs.costIndex.list, {
          pageSize: this.pageSize,
          currentPage: this.page,
          sortColumn: this.defaultSortedBy,
          isAscending: this.defaultSortOrder,
          year: _.get(this.filters, 'year', undefined),
          costIndex: _.get(this.filters, 'costIndex', undefined),
        })
        .then(response => {
          this.tableParams = null
          this.tableParams = params
          this.costList = _.get(response.data, 'result', [])
          this.count = _.get(response.data, 'totalCount', 0)
          this.height = calculateGridHeight(
            'costTable',
            this.count > this.pageSize,
          )
          this.loading = false
          this.loadRefresh = false
          if (type === 'sort') {
            this.updateColumnSettings()
          }
        })
        .catch(error => {
          this.loading = false
          this.loadRefresh = false
          errorService(error)
        })
    },

    // Get HCI By Id
    getCostIndexById(id) {
      this.visible = true
      this.modalTitle = 'Edit'
      this.spinner = true
      this.form.id = null
      this.form.year = undefined
      this.form.costIndex = undefined
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.resetFields()
      }
      instance
        .get(masterAPIs.costIndex.details(id))
        .then(response => {
          this.form = _.get(response.data, 'result', null)
          this.form.costIndex = parseFloat(this.form.costIndex)
            .toFixed(4)
            .toString()
          this.spinner = false
        })
        .catch(error => {
          this.spinner = false
          errorService(error)
        })
    },

    confirmDelete(record) {
      this.loading = true
      const ids = record ? [record.id] : this.selectedRowKeys
      instance
        .patch(masterAPIs.costIndex.delete, ids)
        .then(response => {
          showNotification(
            'success',
            'Delete Historical Cost Index',
            'Historical Cost Index deleted successfully!',
          )
          this.refreshCostIndex()
        })
        .catch(error => {
          this.loading = false
          errorService(error)
        })
    },

    // Delete All HCIs
    deleteAllType() {
      const that = this
      this.$confirm({
        title: `Are you sure you want to delete ${this.selectedRowKeys.length} selected Historical Cost Indexes ?`,
        content: h => (
          <div style="color:red;">
            <p>
              This action will delete all information related to selected
              historical cost index
            </p>
            <p>Please confirm</p>
          </div>
        ),
        onOk() {
          that.confirmDelete()
        },
        onCancel() { },
        class: 'test',
      })
    },

    // Delete HCI
    deleteCostIndex(data) {
      const that = this
      this.$confirm({
        title: `Are you sure you want to delete '${data.year}' ?`,
        content: h => (
          <div style="color:red;">
            <p>
              This action will delete all information related to this historical
              cost index
            </p>
            <p>Please confirm</p>
          </div>
        ),
        onOk() {
          that.confirmDelete(data)
        },
        onCancel() { },
        class: 'test',
      })
    },

    checkboxSelection(params) {
      return params.columnApi.getRowGroupColumns().length === 0
    },

    headerCheckboxSelection(params) {
      return params.columnApi.getRowGroupColumns().length === 0
    },

    // Ag Grid sort method
    sortChanged(value) {
      const colState = this.gridOptions.columnApi.getColumnState()
      const sortData = colState
        .filter(function (s) {
          return s.sort != null
        })
        .map(function (s) {
          return {
            colId: s.colId,
            sort: s.sort,
            sortIndex: s.sortIndex,
          }
        })
      this.loading = true
      this.costList = []
      if (sortData.length > 0) {
        this.defaultSortedBy = sortData[0]['colId']
        this.defaultSortOrder = sortData[0]['sort'] === 'asc'
      } else {
        this.defaultSortedBy = 'year'
        this.defaultSortOrder = false
      }
      this.getCost(this.gridOptions, 'sort')
    },

    onRowSelected(event) {
      const selectedNodes = this.gridOptions.api.getSelectedNodes()
      const selectedData = selectedNodes.map(node => node.data.id)
      this.selectedRowKeys = selectedData
    },

    onSelectionChanged(event) {
      const selectedNodes = this.gridOptions.api.getSelectedNodes()
      const selectedData = selectedNodes.map(node => node.data.id)
      this.selectedRowKeys = selectedData
    },

    getWindowSize() {
      this.height = calculateGridHeight(
        'costTable',
        this.count > this.pageSize,
      )
    },

    onPagination(page) {
      this.loading = true
      this.page = page
      this.costList = []
      this.selectedRowKeys = []
      this.getCost(this.tableParams)
    },

    filterChanged() {
      this.filters = {}
      const data = this.gridOptions.api.getFilterModel()
      Object.keys(data).forEach((element, index) => {
        this.filters[element] = Object.values(data)[index]['filter']
      })
      this.loading = true
      this.page = 0
      this.costList = []
      this.getCost(this.gridOptions)
    },

    changeDate(date) {
      this.form.year = Number(moment(date).format('YYYY'))
    },

    changeTakeoffDate(date) {
      this.takeoffYear = Number(moment(date).format('YYYY'))
      this.updateTakeoffYear()
    },

    isNumber(evt) {
      const splitNumber = this.form.costIndex.split('.')
      if (splitNumber.length === 1) {
        return true
      } else if (splitNumber.length > 1 && splitNumber[1].length > 3) {
        evt.preventDefault()
      } else {
        return true
      }
    },

    updateTakeoffYear() {
      if (this.takeoffYear) {
        instance
          .put(
            settingAPIs.updateTakeoffYear(this.settingId, this.takeoffYear),
            null,
          )
          .then(response => {
            showNotification(
              'success',
              'Takeoff Year',
              'Takeoff Year updated successfully!',
            )
            const settings = JSON.parse(localStorage.getItem('userSettings'))
            localStorage.removeItem('userSettings')
            settings.application.takeoffYear = this.takeoffYear
            localStorage.setItem('userSettings', JSON.stringify(settings))
          })
          .catch(error => {
            errorService(error)
          })
      } else {
        showNotification('error', 'Takeoff Year', 'Please enter Takeoff Year')
      }
    },

    changeTakeoffYear() {
      const reg = /^\d*(d+)?$/
      if (!reg.test(this.takeoffYear)) {
        showNotification(
          'error',
          'Takeoff Year',
          'Please enter valid Takeoff Year',
        )
      } else if (String(this.takeoffYear).length === 4) {
        this.takeoffYear = Number(this.takeoffYear)
        this.updateTakeoffYear()
      }
    },

    // exportClicked
    downloadTemplate() {
      this.exportClicked = true
    },

    clickedCancel() {
      this.exportClicked = false
    },

    handleImport(event) {
      this.importClicked = true
      this.uploadedFile = event.file
      this.loadImport = true
    },

    beforeUpload(file) {
      const isValid =
        file.type === 'xlsx' ||
        file.type === 'xls' ||
        file.type ===
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      if (!isValid) {
        showNotification('error', 'Import', 'Please upload excel file only!')
      }
      return isValid
    },

    updateTable() {
      this.importClicked = false
      this.refreshCostIndex()
    },

    clickedCancelimport(addedCount) {
      this.importClicked = false
      this.loadImport = false
      if (addedCount > 0) {
        this.refreshCostIndex()
      }
    },

    onColumnResized(e) {
      if (e.finished) {
        this.updateColumnSettings()
      }
    },

    updateColumnSettings() {
      if (this.role === 'Admin') {
        this.tableState = this.gridOptions.columnApi.getColumnState()
        const request = {
          type: screenType.historicalCostIndex,
          columnDetails: JSON.stringify(this.tableState),
        }
        this.$emit('updateColumns', request)
      }
    },

    getColumnSettings(params) {
      if (this.role === 'Admin') {
        instance
          .get(masterAPIs.columnSetting.get(screenType.historicalCostIndex))
          .then(response => {
            const tableState = _.get(response.data, 'result.columnDetails', null)
            this.setColumnSettings(params, tableState)
          })
          .catch(error => {
            this.spinner = false
            errorService(error)
          })
      } else {
        this.setColumnSettings(params)
      }
      this.getCost(params)
    },

    setColumnSettings(params, tableState) {
      if (tableState && this.role === 'Admin') {
        this.tableState = JSON.parse(tableState)
        if (this.tableState.find(i => i.sort)) {
          this.defaultSortedBy = this.tableState.find(i => i.sort).colId
          this.defaultSortOrder =
            this.tableState.find(i => i.sort).sort === 'asc'
        }
        this.tableState[0].hide = false
        this.gridOptions.columnApi.applyColumnState({
          state: this.tableState,
        })
      } else {
        this.defaultSortedBy = 'year'
        this.defaultSortOrder = false
        this.gridOptions.columnApi.applyColumnState({
          state: [
            {
              colId: 'year',
              sort: 'desc',
            },
            {
              colId: 'action',
              hide: this.role !== 'Admin',
            },
            {
              colId: '0',
              hide: this.role !== 'Admin',
            },
          ],
          defaultState: { sort: null },
        })
        params.api.sizeColumnsToFit()
      }
    },
  },
}
